import api from './api';

export interface LegalContent {
  privacy_markdown: string | null;
  terms_markdown: string | null;
}

let cached: LegalContent | null = null;

/**
 * Fetch privacy and terms markdown from the public API.
 * Returns null for each field if not configured in admin (use fallback).
 * Result is cached for the session to avoid repeated requests.
 */
export async function getLegalContent(): Promise<LegalContent> {
  if (cached) return cached;
  try {
    const response = await api.get<LegalContent>('/api/legal');
    cached = response.data;
    return cached;
  } catch {
    return { privacy_markdown: null, terms_markdown: null };
  }
}

/** Clear cache (e.g. after admin updates legal content) */
export function clearLegalCache(): void {
  cached = null;
}
